import { useQuery } from '@apollo/client';
import { GetHostStatus, GetInstalledAppDetails } from '@atlassian/mpac-services-client';
import { createInstallAppTargetInput } from '@atlassian/mpac-site-selection';
import { useState } from 'react';
export const useTwoClickAppInstall = _ref => {
  let {
    appKey
  } = _ref;
  const [selectedSiteAndProduct, _] = useState();
  const installAppTargetInput = createInstallAppTargetInput(selectedSiteAndProduct);
  const skipQuery = !selectedSiteAndProduct || !selectedSiteAndProduct.product || !selectedSiteAndProduct.site.cloudId;
  const {
    data: installedAppDetailsResult,
    loading: installedAppDetailsLoading,
    error: installedAppDetailsError
  } = useQuery(GetInstalledAppDetails, {
    variables: {
      input: {
        appKey,
        target: installAppTargetInput
      }
    },
    skip: skipQuery
  });
  const {
    data: hostStatusResult,
    loading: hostStatusLoading,
    error: hostStatusError
  } = useQuery(GetHostStatus, {
    variables: {
      input: installAppTargetInput
    },
    skip: skipQuery
  });
  return {
    installedAppDetailsResponse: {
      installedAppDetailsResult,
      installedAppDetailsLoading,
      installedAppDetailsError
    },
    hostStatusResponse: {
      hostStatusResult,
      hostStatusLoading,
      hostStatusError
    },
    selectedSiteAndProduct
  };
};